"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { pushActivity } from "@/lib/activity-log";

// Lyssnar globalt på klick (på button/a/role=button) och route-changes,
// pushar dem till activity-log-bufferten. Bug-rapport-panelen läser av.
//
// Helt klient-side — ingen server påverkan. Trunkerar text till 80 tecken
// så bufferten håller sig ~5 KB max.

const MAX_LABEL_LEN = 80;

function getLabel(el: Element): string {
  const aria = el.getAttribute("aria-label");
  if (aria) return aria.slice(0, MAX_LABEL_LEN);
  const title = el.getAttribute("title");
  if (title) return title.slice(0, MAX_LABEL_LEN);
  const text = (el.textContent ?? "").trim().replace(/\s+/g, " ");
  if (text) return text.slice(0, MAX_LABEL_LEN);
  return el.tagName.toLowerCase();
}

export default function ActivityTracker() {
  const pathname = usePathname();

  // Logga route-changes
  useEffect(() => {
    if (pathname) {
      pushActivity({ type: "navigering", label: pathname, url: pathname });
    }
  }, [pathname]);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      const target = (e.target as Element | null)?.closest(
        "button, a, [role='button'], [role='tab'], [role='switch']"
      );
      if (!target) return;
      pushActivity({ type: "klick", label: getLabel(target) });
    }
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
